e4.lottiePlayer = {
    init: function () {
        var jPlayers = jQuery( '.js-e-lottie-player' );
        if ( jPlayers.length > 0 ) {
            e4.require.js( e4.settings.require.lottiePlayer, function () {
                    jPlayers.each( function ( intIndex, domPlayer ) {
                        e4.lottiePlayer.bindAnimation( domPlayer );
                    } );
                }
            );
        }
    },
    bindAnimation: function ( domPlayer ) {
        var jPlayer = jQuery( domPlayer ),
            objPlayerData = jPlayer.data(),
            boolLoop = objPlayerData.loop === true,
            objPlayer = lottie.loadAnimation( {
                container: domPlayer,
                renderer: 'svg',
                loop: objPlayerData.loop,
                autoplay: boolLoop,
                path: objPlayerData.animationPath
            } );
        objPlayer.setSpeed( objPlayerData.playSpeed );

        if ( objPlayerData.trigger === 'hover' ) {
            e4.lottiePlayer.triggerOnHover( jPlayer, objPlayer );
        }
        else if ( objPlayerData.trigger === 'click' ) {
            e4.lottiePlayer.triggerOnClick( jPlayer, objPlayer );
        }
        else if ( objPlayerData.trigger === 'viewport' ) {
            e4.lottiePlayer.triggerOnViewportEntry( jPlayer, objPlayer );
        }
    },
    triggerOnHover: function ( jPlayer, objPlayer ) {
        jPlayer.on( 'mouseenter', function () {
            objPlayer.setDirection( 1 );
            objPlayer.play();
        } ).on( 'mouseleave', function () {
            objPlayer.setDirection( -1 );
            objPlayer.play();
        } );
    },
    triggerOnClick: function ( jPlayer, objPlayer ) {
        var intDirection = 1;
        jPlayer.on( 'click', function () {
            objPlayer.play();
            objPlayer.setDirection( intDirection );
            intDirection = intDirection * -1;
        } );
    },
    triggerOnViewportEntry: function ( jPlayer, objPlayer ) {
        e4.util.observer.bind( jPlayer.toArray(), function ( objEntry, objObserver ) {
            if ( objEntry.isIntersecting === true ) {
                objPlayer.setDirection( 1 );
                objPlayer.play();
                objObserver.unobserve( objEntry.target );
            }
        } );
    },
};

